import React, {Component} from "react";
import PropTypes from "prop-types";
import Effects from "./Effects";
import Opacity from "./Opacity";
import Edit from "./Edit";
import ClipartFill from "./ClipartFill";
import Crop from "./Crop";
import Stroke from "./Stroke";
import withErrorBoundary from "../../decorators/withErrorBoundary";
import withSelectionContext from "../../decorators/withSelectionContext";
import Tiling from "./Tiling";

export class EditControl extends Component {
  static propTypes = {
    selected: PropTypes.object
  };
  render() {
    const {selected} = this.props;
    return (
      !!selected && (
        <div className="panel-control panel-control_edit">
          <div className="panel-control__title">Правка и фильтры</div>
          <div className="panel-control__content">
            <Crop selected={selected} />
            <ClipartFill selected={selected} />
            <Effects selected={selected} />
            <Edit selected={selected} />
            <Opacity selected={selected} />
            <Stroke selected={selected} />
            <Tiling selected={selected} />
          </div>
        </div>
      )
    );
  }
}

export default withErrorBoundary(withSelectionContext(EditControl));
